import React, { FC } from 'react'
import cx from 'classnames'
import { Link, useLocation } from 'react-router-dom'
import { Text } from 'components/Text'
import styles from './BillingMenuItem.module.scss'

type BillingMenuItemProps = {
  path: string
  text: string
}

export const BillingMenuItem: FC<BillingMenuItemProps> = (props) => {
  const location = useLocation()

  const classes = cx({
    [styles.isActive]: props.path === location.pathname,
    [styles.billingMenuItem]: styles.billingMenuItem,
  })

  return (
    <Link to={props.path} className={classes}>
      <Text align="right" weight="strong" className={styles.menuText} component="span">
        {props.text}
      </Text>
    </Link>
  )
}

BillingMenuItem.displayName = 'BillingMenuItem'
